import apiChange from '../apiChange';

import { ParamsBodyCreateChangeSolicitationPlatform } from 'utils/typeServices';

type response = {
    success: boolean;
    message: string;
    errorCode: string;
    data: any;
}

export const PostCreateChangeSolicitationPlatform = async ({ body }: { body: ParamsBodyCreateChangeSolicitationPlatform }) => {
    const bodyJson = JSON.stringify(body);
    const token = localStorage.getItem('token');

    try {
        const { data } = await apiChange.post<response>('/changeplatform/createChangeSolicitation/v1', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
